export default "__VITE_ASSET__DC7qgqz9__"